export default __webpack_public_path__ + "static/media/elevate-pyl-poster-3.6471f87c.jpg";